import { useState, useEffect } from 'react'
/*
Breakpoint	Min-width
sm	599px
md	999px
lg	1439px
*/
export const useBreakpoint = () => {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1280
  )

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setWidth(window.innerWidth)
    }

    handleWindowSizeChange()

    window.addEventListener('resize', handleWindowSizeChange)

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const sm = width && width > 599
  const md = width && width > 999
  const lg = width && width > 1439

  return { sm, md, lg }
}
